import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  data: [],
  links: {},
  meta: {},
  // Bumped when the list is replaced rather than extended, so views can scroll back to the top.
  listVersion: 0,
  isFetching: false,
  isUploading: false,
  isLinkUploading: false,
  custom: {
    currentTabs: null,
  },
  callbackData: null,
  isFirstOpenQuery: false,
  filters: {
    leftMenuActiveItem: "",
    rightMenuActiveItem: "all_without_documents",
    search: "",
  },
  uploadProgress: [],
};

export const mediaSlice = createSlice({
  name: "media",
  initialState,
  reducers: {
    setAll: (state, action) => {
      state.data = action.payload.data;
      state.links = action.payload.links;
      state.meta = action.payload.meta;
      state.uploadProgress = [];
      state.listVersion += 1;
    },
    mergePage: (state, action) => {
      const loadedIds = new Set(state.data.map((item) => item.id));
      const newItems = action.payload.data.filter((item) => !loadedIds.has(item.id));
      state.data = [...state.data, ...newItems];
      state.links = action.payload.links;
      state.meta = action.payload.meta;
    },
    removeItem: (state, action) => {
      state.data = state.data.filter((item) => item.id !== action.payload);
    },
    setIsFetching: (state, action) => {
      state.isFetching = action.payload;
    },
    setIsUploading: (state, action) => {
      state.isUploading = action.payload;
    },
    setIsLinkUploading: (state, action) => {
      state.isLinkUploading = action.payload;
    },
    clearAll: (state) => {
      state.data = initialState.data;
      state.links = initialState.links;
      state.meta = initialState.meta;
      state.isFetching = initialState.isFetching;
      state.custom = initialState.custom;
    },
    setMediaMenuCurrentTabs: (state, action) => {
      state.custom.currentTabs = action.payload;
    },
    setCallbackData: (state, action) => {
      state.callbackData = action.payload;
    },
    setIsFirstOpenQuery: (state, action) => {
      state.isFirstOpenQuery = action.payload;
    },
    setFilters: (state, action) => {
      state.filters.leftMenuActiveItem = action.payload.leftMenuActiveItem;
      state.filters.rightMenuActiveItem = action.payload.rightMenuActiveItem;
      state.filters.search = "";
    },
    setFilterByType: (state, action) => {
      state.filters = {
        ...state.filters,
        [action.payload.key]: action.payload.value,
      };
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
    },
    setUploadProgress: (state, action) => {
      const {fileName, progress, url} = action.payload;
      const existingFile = state.uploadProgress.find((file) => file.name === fileName);

      if (existingFile) {
        existingFile.percents = progress;
        if (url) existingFile.url = url;
      } else {
        state.uploadProgress.push({
          name: fileName,
          percents: progress,
          url: url || null,
        });
      }
    },
    clearUploadProgress: (state) => {
      state.uploadProgress = [];
    },
  },
});

export const MediaActions = mediaSlice.actions;
